import { Capacitor } from '@capacitor/core';

/**
 * Push notifications bootstrap for the native mobile apps.
 *
 * No-op on the web build: it only runs inside the native WebView. Delivery
 * still needs Firebase (Android, google-services.json is in place) or APNs
 * (iOS, needs a paid team and the Push Notifications capability in Xcode).
 * See README-mobile.md.
 */
export async function initPushNotifications({ onToken, onNotificationTap } = {}) {
  if (!Capacitor.isNativePlatform()) return;

  // Imported lazily so the web bundle never pulls native-only code.
  const { PushNotifications } = await import('@capacitor/push-notifications');

  try {
    let permission = await PushNotifications.checkPermissions();

    if (permission.receive === 'prompt') {
      permission = await PushNotifications.requestPermissions();
    }

    if (permission.receive !== 'granted') return;

    // Guard against duplicate listeners across re-entry.
    await PushNotifications.removeAllListeners();

    PushNotifications.addListener('registration', (token) => {
      if (typeof onToken === 'function') onToken(token.value);
    });

    PushNotifications.addListener('registrationError', (error) => {
      // eslint-disable-next-line no-console
      console.error('Push registration error:', error);
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      if (typeof onNotificationTap === 'function') onNotificationTap(action.notification);
    });

    await PushNotifications.register();
  } catch (error) {
    // Never let notifications break app startup.
    // eslint-disable-next-line no-console
    console.error('Push notifications init failed:', error);
  }
}
